/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-01-05T10:42:26.407
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinancialElectronicAccount,
	listFinancialElectronicAccountInit,
	listFinancialElectronicAccountByAuthorizations,
	deleteFinancialElectronicAccount
	
} from '@api/financial/FinancialElectronicAccount';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinancialElectronicAccount({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialElectronicAccount(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialElectronicAccountByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialElectronicAccountByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinancialElectronicAccountInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinancialElectronicAccountInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinancialElectronicAccount({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinancialElectronicAccount({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
